var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
    m = s && o[s],
    i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { useFormState } from "./use-form-state";
import { useEntityFormQuery } from "./use-entity-form-query";
import { entityTypeNameFor, ginni } from "@shapeable/utils";
import { entityMutationName, entityMutationQuery, useEntityMutation } from "./use-entity-mutation";
import { useManagement } from "./use-management";
import React from "react";
import { compact, includes, keyBy, mapValues, pickBy } from "lodash";
import { entityFieldMutationValue } from "../utils/entity-field-mutation-value";
import { gql, useApolloClient } from "@apollo/client";
export var useEntityForm = function (options) {
  var _a;
  var client = useApolloClient();
  var entity = options.entity,
    type = options.type,
    _b = options.fields,
    fields = _b === void 0 ? [] : _b,
    entityType = options.entityType,
    entityToDelete = options.entityToDelete;
  if ((type === 'Update' || type === 'Patch' || type === 'Delete') && !entity) {
    throw new Error('useEntityForm: entity required for Update operation');
  }
  ;
  if (type === 'Create' && !entityType) {
    throw new Error('useEntityForm: entityTypeName required for Create operation');
  }
  ;
  // '!' assures TS that the vaue being passed is not null or undefined
  var formName = type === 'Update' || type === 'Patch' || type === 'Delete' ? entity.path : entityType;
  var entityTypeName = type === 'Update' || type === 'Patch' || type === 'Delete' ? entityTypeNameFor(entity) : entityType;
  // const deletionId = (type === 'Delete' && entityId) ? entityId : entity?.id;
  // Omitting the id to ensure create operations don't have an id
  var queryParams = {
    entityTypeName: entityTypeName,
    type: type,
    fields: fields
  };
  if (type === 'Update' || type === 'Patch' || type === 'Delete') {
    queryParams.id = entity.id;
  }
  ;
  var formState = useFormState(formName);
  var management = useManagement();
  var result = useEntityFormQuery(queryParams);
  var formEntity = result.data;
  // handle this better? -------- 
  var fieldsToUse = type === 'Delete' ? [] : (fields.length ? fields : (_a = result.entityTypeDefinition) === null || _a === void 0 ? void 0 : _a.formFields) || []; // replaced "fields" with "formFields" on entityTypeDefinition
  var mutation = useEntityMutation(__assign(__assign({
    entityTypeName: entityTypeName,
    type: type
  }, type === 'Update' ? {
    id: entity.id
  } : {}), {
    fields: fieldsToUse
  }));
  var autoFocusUsed = false;
  ginni.verbose.log("FIELDS TO USE", fieldsToUse);
  var formFields = compact(fieldsToUse.map(function (fieldSpec, index) {
    /* @ts-ignore */
    if (fieldSpec.type === 'custom') {
      return null; // these fields should not come through
    }
    ;
    var autoFocus = false;
    if (!autoFocusUsed && fieldSpec.formFieldType !== 'hidden') {
      autoFocus = true;
      autoFocusUsed = true;
    }
    ;
    var field = {
      autoFocus: autoFocus,
      fieldDefinition: fieldSpec,
      type: fieldSpec.formFieldType || 'hidden',
      name: fieldSpec.name,
      // this has now changed from being the form defintion to the field itself - do we need the definition for the overall form??
      entityTypeDefinition: fieldSpec.entityTypeDefinition,
      // supportingEntityTypeDefinitions: result.supportingEntityTypeDefinitions,
      // data: result?.fieldData?.[fieldSpec.name] || {},
      label: fieldSpec.label,
      description: (management.isOwn ? fieldSpec.ownDescription || fieldSpec.description : fieldSpec.description) || '',
      required: fieldSpec.required,
      entityTypeName: fieldSpec.entityTypeName
    };
    return field;
  }));
  // for any linked entities, we need to load in the options for the select fields
  // --- SET INITIAL STATE of FORM
  React.useEffect(function () {
    if (formEntity && type === 'Update') {
      var formFieldsByName = keyBy(formFields, 'name');
      var formFieldsState = formEntity ? mapValues(formFieldsByName, function (formField) {
        return {
          value: formEntity[formField.name],
          // result?.fieldValues?.[field.name] || (entityFormFieldExtract(formEntity[field.name], field) || ''), 
          mutationValue: entityFieldMutationValue(formEntity[formField.name], formField.fieldDefinition) || '',
          isValid: true,
          required: formField.required
        };
      }) : {};
      // setIsReady({ ...isReady, [formName]: true });
      // NB: patchFields will set isReady to true, as it is assumed that the fields are now loaded
      formState.patchFields(formFieldsState);
    }
  }, [formEntity]);
  var submit = function () {
    return __awaiter(void 0, void 0, void 0, function () {
      var mutationInput, formFields_1, formFields_1_1, field, fieldState, _loop_1, _a, _b, cascadedMutation, e_1_1, e_2_1, input, result;
      var e_2, _c, e_1, _d;
      var _e, _f, _g;
      return __generator(this, function (_h) {
        switch (_h.label) {
          case 0:
            formState.patch({
              isSubmitting: true
            });
            mutationInput = __assign({}, (formState === null || formState === void 0 ? void 0 : formState.mutationValue) || {});
            _h.label = 1;
          case 1:
            _h.trys.push([1, 12, 13, 14]);
            formFields_1 = __values(formFields), formFields_1_1 = formFields_1.next();
            _h.label = 2;
          case 2:
            if (!!formFields_1_1.done) return [3 /*break*/, 11];
            field = formFields_1_1.value;
            fieldState = formState.fields[field.name];
            if (!(fieldState && ((_e = fieldState.cascadedMutations) === null || _e === void 0 ? void 0 : _e.length))) return [3 /*break*/, 10];
            _loop_1 = function (cascadedMutation) {
              var mutationQuery, variables, result_1, dataKey, resultEntity, newId_1, refId_1;
              return __generator(this, function (_j) {
                switch (_j.label) {
                  case 0:
                    ginni.verbose.log("Cascaded mutation", {
                      cascadedMutation: cascadedMutation
                    });
                    mutationQuery = entityMutationQuery({
                      type: cascadedMutation.type,
                      entityTypeName: cascadedMutation.entityTypeName,
                      fields: ((_f = field.entityTypeDefinition) === null || _f === void 0 ? void 0 : _f.formFields) || []
                    });
                    ginni.verbose.log("Mutation Query", {
                      mutationQuery: mutationQuery
                    });
                    variables = pickBy({
                      id: includes(['Update', 'Delete', 'Patch'], cascadedMutation.type) && cascadedMutation.refId,
                      input: cascadedMutation.input
                    });
                    if (!cascadedMutation.refId) return [3 /*break*/, 2];
                    ginni.verbose.log("Cascaded mutation variables", {
                      variables: variables
                    });
                    return [4 /*yield*/, client.mutate({
                      mutation: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", ""], ["", ""])), mutationQuery),
                      variables: variables
                    })];
                  case 1:
                    result_1 = _j.sent();
                    dataKey = entityMutationName(cascadedMutation.type, cascadedMutation.entityTypeName);
                    resultEntity = (_g = result_1.data) === null || _g === void 0 ? void 0 : _g[dataKey];
                    if (resultEntity) {
                      // Handle the result of the mutation if needed
                      ginni.verbose.log("Cascaded mutation result entity", resultEntity);
                      if (cascadedMutation.type === 'Create' && resultEntity.id) {
                        newId_1 = resultEntity.id;
                        // Update the overall mutationInput with any IDs cross-referenced 
                        // here, we are going to assume that the field value is an array of IDs, as this is only used for linked junctions  
                        if (mutationInput[field.name] && Array.isArray(mutationInput[field.name])) {
                          refId_1 = cascadedMutation.refId;
                          mutationInput[field.name] = mutationInput[field.name].map(function (id) {
                            // If the ID matches the refId, replace it with the new ID from the mutation result
                            if (id === refId_1) {
                              return newId_1;
                            }
                            // Otherwise, keep the original ID
                            return id;
                          });
                        }
                      }
                    } else {
                      // Handle the error if needed
                      console.error("Cascaded mutation error", result_1.errors);
                    }
                    _j.label = 2;
                  case 2:
                    return [2 /*return*/];
                }
              });
            };
            _h.label = 3;
          case 3:
            _h.trys.push([3, 8, 9, 10]);
            _a = (e_1 = void 0, __values(fieldState.cascadedMutations)), _b = _a.next();
            _h.label = 4;
          case 4:
            if (!!_b.done) return [3 /*break*/, 7];
            cascadedMutation = _b.value;
            return [5 /*yield**/, _loop_1(cascadedMutation)];
          case 5:
            _h.sent();
            _h.label = 6;
          case 6:
            _b = _a.next();
            return [3 /*break*/, 4];
          case 7:
            return [3 /*break*/, 10];
          case 8:
            e_1_1 = _h.sent();
            e_1 = {
              error: e_1_1
            };
            return [3 /*break*/, 10];
          case 9:
            try {
              if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
            } finally {
              if (e_1) throw e_1.error;
            }
            return [7 /*endfinally*/];
          case 10:
            formFields_1_1 = formFields_1.next();
            return [3 /*break*/, 2];
          case 11:
            return [3 /*break*/, 14];
          case 12:
            e_2_1 = _h.sent();
            e_2 = {
              error: e_2_1
            };
            return [3 /*break*/, 14];
          case 13:
            try {
              if (formFields_1_1 && !formFields_1_1.done && (_c = formFields_1.return)) _c.call(formFields_1);
            } finally {
              if (e_2) throw e_2.error;
            }
            return [7 /*endfinally*/];
          case 14:
            // If the mutation type is 'Delete', we only need to submit the id, skipping the name check.
            if (type === 'Delete') {
              return [2 /*return*/, mutation.submit({
                variables: {
                  id: entity.id
                }
              })];
            }
            ;
            if (!formState.mutationValue.name && !(entity === null || entity === void 0 ? void 0 : entity.name) && !(formEntity === null || formEntity === void 0 ? void 0 : formEntity.name)) {
              // Prompt the user to fill in the name field
              alert("Please enter a name before saving.");
              return [2 /*return*/];
            }
            input = __assign(__assign({}, mutationInput), {
              name: formState.mutationValue.name || (entity === null || entity === void 0 ? void 0 : entity.name) || (formEntity === null || formEntity === void 0 ? void 0 : formEntity.name)
            });
            if (!(type === 'Update')) return [3 /*break*/, 16];
            return [4 /*yield*/, mutation.submit({
              variables: {
                id: entity.id,
                input: input
              }
            })];
          case 15:
            result = _h.sent();
            return [3 /*break*/, 18];
          case 16:
            return [4 /*yield*/, mutation.submit({
              variables: {
                input: input
              }
            })];
          case 17:
            result = _h.sent();
            _h.label = 18;
          case 18:
            if (result.data) {
              formState.reset();
            }
            return [2 /*return*/, result];
        }
      });
    });
  };
  var isLoading = type === 'Update' ? !formEntity || mutation.loading : mutation.loading;
  var isSubmitting = mutation.loading || formState.isSubmitting;
  var disabledActions = compact([(isLoading || isSubmitting || formState.isValid === false) && 'save', isSubmitting && 'cancel']);
  var loadingActions = compact([isSubmitting && 'save']);
  // console.log("FORM STATE", formState);
  // const isReady = type === 'Update' ? !!formEntity : !!result.entityTypeDefinition;
  // if (isReady) {
  //   console.log("IS READY", type, formEntity, formState);
  // }
  return {
    isLoading: isLoading,
    disabledActions: disabledActions,
    loadingActions: loadingActions,
    entityTypeDefinition: result.entityTypeDefinition,
    // supportingEntityTypeDefinitions: result.supportingEntityTypeDefinitions,
    isReady: type === 'Create' ? !!result.entityTypeDefinition : formState.isReady,
    isSubmitting: mutation.loading,
    submit: submit,
    name: formName,
    fields: formFields,
    state: formState,
    mutation: mutation
  };
};
var templateObject_1;